import { useEffect, useRef, useState } from "react";
import "./select.css";
import { Icon } from "../icon";
import type { IconName } from "../icon/IconName";

export type SelectItem = {
  label: string;
  iconName?: IconName;
  onClick: () => void;
};

interface SelectProps {
  label: string;
  items: SelectItem[];
}

export default function Select({
  label,
  items,
}: SelectProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="select" ref={ref}>
      <button
        type="button"
        className="select-trigger"
        onClick={() => setOpen((prev) => !prev)}
      >
        {label}
      <Icon name="chevron-down"></Icon>
      </button>

      {open && (
        <div className="select-dropdown">
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              className="select-item"
              onClick={() => {
                item.onClick();
                setOpen(false);
              }}
            >
              {item.iconName && <Icon name={item.iconName}></Icon>}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}